var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.348 12.948L2.4 19.908V18A1.2 1.2 0 100 18v4.8a1.2 1.2 0 00.096.456 1.2 1.2 0 00.648.648c.144.061.3.094.456.096H6a1.2 1.2 0 100-2.4H4.092l6.96-6.948a1.205 1.205 0 10-1.704-1.704zM23.904.744a1.2 1.2 0 00-.648-.648A1.2 1.2 0 0022.8 0H18a1.2 1.2 0 100 2.4h1.908l-6.96 6.948a1.201 1.201 0 000 1.704 1.202 1.202 0 001.704 0l6.948-6.96V6A1.2 1.2 0 1024 6V1.2a1.2 1.2 0 00-.096-.456z",
    fill: "currentColor"
  })));
}
export default SvgVector;